module.exports = __webpack_public_path__ + "static/media/lds-logo_ja.80118875.svg";